import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import CheckoutForm from '../../components/Checkout/CheckoutForm';
import { CheckoutProvider } from '../../context/CheckoutContext';
import './Checkout.scss';

const Checkout = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
  }, []);

  const initialData = {
    full_name: searchParams.get('name') ?? undefined,
    email: searchParams.get('email') ?? undefined,
  };

  const planIdParam = searchParams.get('plan_id');
  const initialPlanId = planIdParam ? parseInt(planIdParam, 10) : undefined;

  return (
    <div className="checkout-page">
      <CheckoutProvider initialData={initialData} initialPlanId={initialPlanId}>
        <CheckoutForm />
      </CheckoutProvider>
    </div>
  );
};

export default Checkout;
